export const customScript = (
  templateId,
  wrapperFormTypeCount,
  wrapperDiscountTypeCount,
  wrapperPhoneInputTypeCount,
) => {
  let result = '';

  const generalForms = `
    var generatedToken = '';
    var siteKey = '';
    const forms = document.querySelectorAll('form');

    Array.from(document.getElementsByTagName('script')).forEach(item => {
      if(item.src && item.src.startsWith('https://www.google.com/recaptcha/api.js?render=')) {
        siteKey = item.src.replace('https://www.google.com/recaptcha/api.js?render=','');
      }
    });

    if(window.grecaptcha && siteKey) {
      window.grecaptcha.ready(function () {
        window.grecaptcha
          .execute(siteKey, { action: "submit" })
          .then(function (token) {
            forms.forEach((form) => {
              generatedToken = token;
            });
          });
      });
    }

    function fadeOut(el) {
      el.style.opacity = 1;
      (function fade() {
        if ((el.style.opacity -= 0.1) < 0) {
          el.style.display = 'none';
        } else {
          requestAnimationFrame(fade);
        }
      })();
    }

    function fadeIn(el, display) {
      el.style.opacity = 0;
      el.style.display = display || 'block';
      (function fade() {
        var val = parseFloat(el.style.opacity);
        if (!((val += 0.1) > 1)) {
          el.style.opacity = val;
          requestAnimationFrame(fade);
        }
      })();
    }

    forms.forEach((form) => {
      if(form.querySelector('.state-error')) {
        form.querySelector('.state-error').style.display = "none";
      }
      if(form.querySelector('.state-success')) {
        form.querySelector('.state-success').style.display = "none";
      }
      if(form.querySelector('.email-error')) {
        form.querySelector('.email-error').style.display = "none";
      }
      if(form.querySelector('.form-content')) {
        form.querySelector('.form-content').style.display = "block";
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        const formData = new FormData(e.target);
        const formValues = Object.fromEntries(formData.entries());
        const submitBtn = this.querySelector('button[type=submit]');
        const errorState = this.querySelector('.state-error:not(.email-error)');
        const emailError = this.querySelector('.email-error');
        const successState = this.querySelector('.state-success');
        const formContent = this.querySelector('.form-content');
        const redirectUrl = this.getAttribute('redirect') || '';
        const hasEmailType = Array.from(this).some(
          (item) => item.nodeName === 'INPUT' && item.type === 'email',
        );
        const formPayload = { ...formValues };
        const phoneInput = Array.from(this).find(
          (item) => item.nodeName === 'INPUT' && item.type === 'tel',
        );

        if (phoneInput) {
          phoneInput.setCustomValidity('');
          if (phoneInput.required && phoneInput.value.trim().length <= 3) {
            phoneInput.setCustomValidity('Please enter your full phone number.');
            phoneInput.reportValidity();
            setTimeout(() => {
              phoneInput.setCustomValidity('');
              phoneInput.reportValidity();
            }, 2000);
            return;
          } else if (!phoneInput.required && phoneInput.value.trim().length <= 3) {
            formPayload['phone'] = '';
            phoneInput.setCustomValidity('');
          }
        }

        const formSubmitAction = '/form/submit';

        if (!generatedToken || !siteKey) {
          fadeIn(errorState);
          setTimeout(function () {
            fadeOut(emailError);
          }, 3000);
          return false;
        }

        if (!hasEmailType) {
          fadeIn(emailError);
          setTimeout(function () {
            fadeOut(emailError);
          }, 3000);
          return false;
        }

        submitBtn.disabled = true;

        fetch(formSubmitAction, {
          method: 'POST',
          body: JSON.stringify({
            formData: {
              ...formPayload,
            },
            recaptchaToken: generatedToken,
            templateId: '${templateId}',
          }),
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          },
        })
          .then(function (formSubmitResponse) {
            generatedToken = '';
            if (formSubmitResponse && formSubmitResponse.ok) {
              formContent.style.display = 'none';
              errorState.style.display = 'none';
              fadeIn(successState);
            } else {
              fadeIn(errorState);
            }
          })
          .catch((err) => {
            console.log(err);
            fadeIn(errorState);
          })
          .finally(function () {
            submitBtn.disabled = false;
            if (redirectUrl) {
              setTimeout(function () {
                window.location.href = redirectUrl;
              }, 2000);
            }
          });
      });
    });

    (function () {
      function initIntlTelInputs() {
        const phoneInputs = document.querySelectorAll('input[type=tel]');
        phoneInputs.forEach((phoneInput) => {
          if (!phoneInput.classList.contains('iti-initialized')) {
            setTimeout(function () {
              const itiInstance = window.intlTelInput(phoneInput, {
                initialCountry: 'auto',
                geoIpLookup: function (callback) {
                  fetch('https://ipapi.co/json/')
                    .then((resp) => resp.json())
                    .then((data) => {
                      const countryCode = data && data.country ? data.country : 'us';
                      callback(countryCode.toLowerCase());
                    })
                    .catch(() => {
                      callback('us');
                    });
                },
                utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@19.5.3/build/js/utils.js',
              });

              itiInstance.promise.then(() => {
                const countryData = itiInstance.getSelectedCountryData();
                const dialCode = countryData?.dialCode;
                if (dialCode && !phoneInput.value) {
                  phoneInput.value = '+' + dialCode;
                }

                phoneInput.addEventListener('input', () => {
                  if (!phoneInput.value.startsWith('+')) {
                    phoneInput.value = '+' + phoneInput.value;
                  }
                });

                phoneInput.addEventListener('keydown', (e) => {
                  const cursorPosition = phoneInput.selectionStart;
                  if (
                    (e.key === 'Backspace' || e.key === 'Delete') &&
                    cursorPosition <= 1
                  ) {
                    e.preventDefault();
                  }
                });
              });

              phoneInput.classList.add('iti-initialized');
            }, 1000);
          }
        });
      }

      window.addEventListener('load', initIntlTelInputs);

      const observer = new MutationObserver(() => {
        initIntlTelInputs();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    })();
  `;

  const discountCodes = `
    const discountCodes = Array.from(
      document.querySelectorAll('[data-type="discount-code"]'),
    );

    discountCodes.forEach((code) => {
      const codeInput = code.querySelector('input');
      const codeButton = code.querySelector('button');

      codeButton.addEventListener('click', () => {
        if (navigator.permissions) {
          navigator.permissions
            .query({
              name: 'clipboard-write',
            })
            .then(async (result) => {
              if (result.state !== 'denied') {
                await navigator.clipboard.writeText(
                  codeInput?.value || '',
                );

                code.classList.add('copied');
                codeButton.innerText = 'copied';
              }
            })
            .catch((err) => console.error(err));
        }
      });
    });
  `;

  const phoneInputCodesScript = `
    (function () {
      function initIntlTelInputs() {
        const phoneInputs = document.querySelectorAll('input[type=tel]');
        phoneInputs.forEach((phoneInput) => {
          if (!phoneInput.classList.contains('iti-initialized')) {
            setTimeout(function () {
              const itiInstance = window.intlTelInput(phoneInput, {
                initialCountry: 'auto',
                geoIpLookup: function (callback) {
                  fetch('https://ipapi.co/json/')
                    .then((resp) => resp.json())
                    .then((data) => {
                      const countryCode = data && data.country ? data.country : 'us';
                      callback(countryCode.toLowerCase());
                    })
                    .catch(() => {
                      callback('us');
                    });
                },
                utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@19.5.3/build/js/utils.js',
              });
              itiInstance.promise.then(() => {
                const countryData = itiInstance.getSelectedCountryData();
                const dialCode = countryData?.dialCode;
                phoneInput.value = dialCode ? '+' + dialCode : '';

                phoneInput.addEventListener('input', () => {
                  if (!phoneInput.value.startsWith('+')) {
                    phoneInput.value = '+' + phoneInput.value;
                  }
                });
                phoneInput.addEventListener('keydown', (e) => {
                  const cursorPosition = phoneInput.selectionStart;
                  if (
                    (e.key === 'Backspace' || e.key === 'Delete') &&
                    cursorPosition <= 1
                  ) {
                    e.preventDefault();
                  }
                });
              });
              phoneInput.classList.add('iti-initialized');
            }, 1000);
          }
        });
      }

      window.addEventListener('load', initIntlTelInputs);

      const observer = new MutationObserver(() => {
        initIntlTelInputs();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    })();
  `;

  if (wrapperFormTypeCount > 0) {
    result += generalForms;
  }

  if (wrapperDiscountTypeCount > 0) {
    result += discountCodes;
  }

  if (wrapperPhoneInputTypeCount > 0) {
    result += phoneInputCodesScript;
  }

  return result;
};
